import React, {useContext, useEffect, useState} from 'react';
import {Dropdown, Form, Spinner} from "react-bootstrap";
import {createGenre, fetchGenre} from "../../../http/bookAPI";
import Modal from "react-bootstrap/Modal";
import {Context} from "../../../index";
import {observer} from "mobx-react-lite";

const CreateGenre = observer(({ show, handleClose }) => {
    const {book} = useContext(Context)
    const [value, setValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchGenre().then(data => book.setGenres(data))
    }, []);

    const addGenre = async () => {
        setLoading(true);
        setError('');
        try {
            await createGenre({ genre: value });
            const updatedGenres = await fetchGenre(); // Обновляем список жанров после изменения
            book.setGenres(updatedGenres);
            book.setSelectedGenre({}); // Сбрасываем выбранный жанр
            setValue(''); // Очищаем поле ввода
            handleClose(); // Закрываем модальное окно
        } catch (e) {
            const errorMessage = e.response?.data?.message || 'An error occurred while adding the genre.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={() => { setError(''); handleClose(); }} centered>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Add a new Genre</h1>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                    ></button>
                </div>



                <div className="modal-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <Form>
                        <Form.Control
                            value={value}
                            onChange={e => setValue(e.target.value)}
                            placeholder="Enter name of new Genre"
                            disabled={loading}
                        />
                    </Form>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                        disabled={loading}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={addGenre}
                        disabled={!value.trim() || loading}
                    >
                        {loading ? <Spinner as="span" animation="border" size="sm"/> : 'Add in DB'}
                    </button>

                </div>
            </div>
        </Modal>
    );
});

export default CreateGenre;
